import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { useToast } from './ui';
import ProductImage from './ProductImage';
import './FrequentlyBoughtTogether.css';

export default function FrequentlyBoughtTogether({ productId }) {
  const [items, setItems] = useState(null);
  const { addToCart } = useCart();
  const toast = useToast();

  useEffect(() => {
    if (!productId) return;
    fetch(`/api/recommendations/fbt/${productId}`)
      .then(r => r.ok ? r.json() : [])
      .then(setItems)
      .catch(() => setItems([]));
  }, [productId]);

  if (!items || items.length === 0) return null;

  return (
    <section className="fbt">
      <h3 className="fbt__heading">Frequently bought together</h3>
      <div className="fbt__row">
        {items.map(p => (
          <article key={p.id} className="fbt__card">
            <Link to={`/product/${p.id}`} className="fbt__link">
              <ProductImage product={p} alt={p.name} className="fbt__img" />
              <div className="fbt__name">{p.name}</div>
              <div className="fbt__price">${Number(p.price).toFixed(2)}</div>
            </Link>
            <button
              type="button"
              className="fbt__add"
              onClick={() => { addToCart(p, 1); toast.success(`${p.name} added`); }}
            >+ Add</button>
          </article>
        ))}
      </div>
    </section>
  );
}
